import { useEffect, useState } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { useCart } from "../context/CartContext";
import { analyticsConsent } from "../lib/analytics";

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (hash) return; // preserve anchor behavior
    if (navType === "POP") return; // browser back/forward keeps its position
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, navType]);
  return null;
};

export const BackToTop = () => {
  const { count } = useCart();
  const [show, setShow] = useState(false);
  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { setShow(window.scrollY > 500); ticking = false; });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  const consentPending = !analyticsConsent();
  const bottom = consentPending
    ? "bottom-[calc(8.5rem+env(safe-area-inset-bottom))] md:bottom-24"
    : count > 0
      ? "bottom-[calc(5.5rem+env(safe-area-inset-bottom))] md:bottom-6"
      : "bottom-[calc(1.25rem+env(safe-area-inset-bottom))] md:bottom-6";
  const toTop = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    const main = document.querySelector("main");
    if (main) { main.setAttribute("tabindex", "-1"); main.focus({ preventScroll: true }); }
  };
  return (
    <button data-testid="back-to-top-button" aria-label="Back to top" onClick={toTop}
      className={`fixed right-4 z-40 h-11 w-11 flex items-center justify-center bg-[#171715] text-[#FBF6F1] border border-[#FBF6F1]/20 shadow-lg hover:bg-[#A35847] transition-colors ${bottom}`}>
      <ArrowUp size={18} aria-hidden="true" />
    </button>
  );
};
